import OrderIndex from "@/components/Order/Index.vue";
import SAPOrderIndex from "@/components/SAPOrder/Index.vue";
import SAPOrderEditor from "@/components/SAPOrder/Editor.vue";
import SAPOrderFilter from "@/components/SAPOrder/Filter.vue";

export default [
    {
        path: "/Order/Index",
        name: "OrderIndex",
        component: OrderIndex,
        meta: {
            name: "OrderIndex",
            menuTitle: "Order",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Order/Editor",
        name: "OrderEditor",
        component:  () => import("@/components/Order/Editor.vue"),
        meta: {
            name: "OrderEditor",
            menuTitle :"Order",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SAPOrder/Index",
        name: "SAPOrderIndex",
        component: SAPOrderIndex,
        meta: {
            name: "SAPOrderIndex",
            menuTitle: "SAP Order",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SAPOrder/Editor",
        name: "SAPOrderEditor",
        component: SAPOrderEditor,
        meta: {
            name: "SAPOrderEditor",
            menuTitle: "SAP Order",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SAPOrder/Filter",
        name: "SAPOrderFilter",
        component: SAPOrderFilter,
        meta: {
            name: "SAPOrderFilter",
            menuTitle: "SAP Order",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Shipment/Index",
        name: "ShipmentIndex",
        component: () => import("@/components/Shipment/Index.vue"),
        meta: {
            name: "ShipmentIndex",
            menuTitle: "Shipment",
            requiresAuth: true

        },
        props: true
    },
    {
        path: "/Shipment/ChangeShipmentStatus",
        name: "ShipmentChangeShipmentStatus",
        component: () => import("@/components/Shipment/ChangeShipmentStatus.vue"),
        meta: {
            name: "ShipmentChangeShipmentStatus",
            menuTitle: "Change Shipment Status",
            requiresAuth: true

        },
        props: true
    },
    {
        path: "/Approval/Index",
        name: "ApprovalIndex",
        component: () => import("@/components/Approval/Index.vue"),
        meta: {
            name: "ApprovalIndex",
            menuTitle: "Approval",
            requiresAuth: true
        },
        props: true
    },
    {
        path:"/IPB/Index",
        name:"IPBIndex",
        component:()=>import("@/components/IPB/Index.vue"),
        meta:{
            name:"IPBIndex",
            menuTitle:"IPB",
            requiresAuth:true
        },
        props:true
    },
    {
        path:"/IPB/Editor",
        name:"IPBEditor",
        component:()=>import("@/components/IPB/Editor.vue"),
        meta:{
            name:"IPBEditor",
            menuTitle:"IPB",
            requiresAuth:true
        },
        props:true
    },
    {
        path: "/STO/Index",
        name: "STOIndex",
        component: () => import("@/components/STO/Index.vue"),
        meta: {
            name: "STOIndex",
            menuTitle: "STO",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/STO/Editor",
        name: "STOEditor",
        component: () => import("@/components/STO/Editor.vue"),
        meta: {
            name: "STOEditor",
            menuTitle: "STO",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SPO/Index",
        name: "SPOIndex",
        component: () => import("@/components/SPO/Index.vue"),
        meta: {
            name: "SPOIndex",
            menuTitle: "SPO",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SPO/Editor",
        name: "SPOEditor",
        component: () => import("@/components/SPO/Editor.vue"),
        meta: {
            name: "SPOEditor",
            menuTitle: "SPO",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SPOAdjustment/Index",
        name: "SPOAdjustmentIndex",
        component: () => import("@/components/SPOAdjustment/Index.vue"),
        meta: {
            name: "SPOAdjustmentIndex",
            menuTitle: "SPOAdjustment",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SPOAdjustment/Editor",
        name: "SPOAdjustmentEditor",
        component: () => import("@/components/SPOAdjustment/Editor.vue"),
        meta: {
            name: "SPOAdjustmentEditor",
            menuTitle: "SPOAdjustment",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/UnlockTransaction/Index",
        name: "UnlockTransactionIndex",
        component: () => import("@/components/UnlockTransaction/Index.vue"),
        meta: {
            name: "UnlockTransactionIndex",
            menuTitle: "Unlock Transaction",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Util/ChangeSTOSPOStatus",
        name: "ChangeSTOSPOStatus",
        component: () => import("@/components/Util/ChangeSTOSPOStatus.vue"),
        meta: {
            name: "ChangeSTOSPOStatus",
            menuTitle: "Change STO/SPO Status",
            requiresAuth: true
        },
        props: true
    },
    
]